import axios from './axiosWrapper';

function unwrapFalconPayload(res) {
    const body = res?.data;
    if (body && typeof body === 'object' && 'data' in body) {
        return body.data;
    }
    return body;
}

function withUnwrappedData(promise) {
    return promise.then((res) => ({
        ...res,
        data: unwrapFalconPayload(res),
    }));
}

const Batch = {
    getDepartments(institutionID) {
        return withUnwrappedData(
            axios.get(`/batch/departments/${encodeURIComponent(String(institutionID || ''))}`)
        );
    },
    getSpecialisations(institutionID, departmentID) {
        return withUnwrappedData(
            axios.get(
                `/batch/specialisations/${encodeURIComponent(String(institutionID || ''))}/department/${encodeURIComponent(
                    String(departmentID || '')
                )}`
            )
        );
    },
    listBatches(institutionID, { departmentID, specialisationID, section, limit = 10, lastEvaluatedKey } = {}) {
        const params = new URLSearchParams();
        params.set('limit', String(limit));
        if (departmentID) params.set('departmentID', departmentID);
        if (specialisationID) params.set('specialisationID', specialisationID);
        if (section !== undefined && section !== null) params.set('section', section);
        if (lastEvaluatedKey) params.set('lastEvaluatedKey', lastEvaluatedKey);

        return withUnwrappedData(
            axios.get(`/batch/${encodeURIComponent(String(institutionID || ''))}?${params.toString()}`)
        );
    },
};

export default Batch;
